// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"saved-report-drag__visuallyhidden--H2Uv6","focusable":"saved-report-drag__focusable--fjw0o","dragable":"saved-report-drag__dragable--AiNge"};